import React, { useCallback } from 'react';
import { TMenuContentVersion } from 'types';
import { Checkbox, Form } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import Text from 'components/Text/Text';

interface IUseCustomerContentVersionCheckBox {
	toggleUseContentVersion: (value: TMenuContentVersion) => void;
	useContentVersion: TMenuContentVersion;
}

const UseCustomerContentVersionCheckBox: React.FC<IUseCustomerContentVersionCheckBox> = ({
	toggleUseContentVersion,
	useContentVersion,
}) => {
	const handleChange = useCallback(
		(e: CheckboxChangeEvent) => {
			if (e.target.checked) {
				toggleUseContentVersion('Customer');
			} else {
				toggleUseContentVersion('None');
			}
		},
		[toggleUseContentVersion],
	);

	return (
		<Form.Item name="useContentVersion">
			<Checkbox checked={useContentVersion === 'Customer'} onChange={handleChange}>
				<Text translationNameSpace="form" translationKey="useCustomerContentVersionLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
};

export default React.memo(UseCustomerContentVersionCheckBox);
